<se-fe-page
  [seFeDataLoaded]="(loading$ | async) === false"
  seFeDataWidth="full"
  [seFeDataBackLink]="backLink"
  seFeDataBackText="Back"
  class="catalog-detail">
  <se-fe-header
    seFePageHeader
    [seFeDataTitle]="(catalog$ | async)?.name ?? 'Catalog details'"
    size="750"></se-fe-header>

  <ng-container seFePageContent>
    @if (error$ | async; as error) {
      <se-fe-alert seFeDataType="error" class="catalog-detail__error">
        Catalog details could not be loaded
        <se-fe-alert-subheader>{{ error.message }}</se-fe-alert-subheader>
      </se-fe-alert>
    }

    @if (catalog$ | async; as catalog) {
      <se-fe-grid id="catalog-detail__layout" seFeGridOpts>
        <se-fe-grid-cell id="catalog-detail__products" seFeGridOpts="1/1@mobile 2/3@desktop">
          <se-fe-card>
            <se-fe-card-header [seFeDataTitle]="catalog.name + ' products'" [seFeDataHeavyBorder]="true">
              <div seFeCardHeaderActions class="catalog-detail__chooser-action">
                @if (activeCatalogTab() === 'products') {
                  <app-choose-catalog-products-modal></app-choose-catalog-products-modal>
                } @else {
                  <choose-catalog-bundles-modal></choose-catalog-bundles-modal>
                }
              </div>
            </se-fe-card-header>

            <se-fe-card-content class="catalog-detail__products-content">
              <se-fe-tab-group [seFeDataTabPanel]="catalogItemsPanel" seFeDataAriaLabel="Catalog items">
                <se-fe-tab-item>
                  <a
                    [seFeTab]="activeCatalogTab() === 'products'"
                    (click)="selectCatalogTab('products')"
                    (keydown.enter)="selectCatalogTab('products')"
                    (keydown.space)="selectCatalogTab('products')">
                    Products
                  </a>
                </se-fe-tab-item>
                <se-fe-tab-item>
                  <a
                    [seFeTab]="activeCatalogTab() === 'bundles'"
                    (click)="selectCatalogTab('bundles')"
                    (keydown.enter)="selectCatalogTab('bundles')"
                    (keydown.space)="selectCatalogTab('bundles')">
                    Bundles
                  </a>
                </se-fe-tab-item>
              </se-fe-tab-group>

              <se-fe-tab-panel #catalogItemsPanel class="catalog-detail__tab-panel">
                @if (activeCatalogTab() === 'products') {
                  @if (productsError$ | async; as productsError) {
                    <se-fe-alert seFeDataType="error">
                      Catalog products could not be loaded
                      <se-fe-alert-subheader>{{ productsError.message }}</se-fe-alert-subheader>
                    </se-fe-alert>
                  }

                  <product-table
                    mode="catalogDetail"
                    linkPrefix="../../products/"
                    [loading]="(productsLoading$ | async) ?? false"
                    [products]="(products$ | async) ?? []"
                    [paginationEnabled]="true"
                    [paginationOptions]="(productPaginationOptions$ | async) ?? undefined"
                    [query]="(productQuery$ | async) ?? ''"
                    [selectable]="true"
                    [selectedRowIds]="selectedProductIds()"
                    [showRemove]="true"
                    [showSearch]="true"
                    [showToolbarFilters]="false"
                    [showCatalogEmptyState]="true"
                    [sortBy]="(productSortBy$ | async) ?? undefined"
                    [sortDirection]="(productSortDirection$ | async) ?? undefined"
                    (queryChanged)="productQueryChanged($event)"
                    (removeProduct)="removeProductFromCatalog($event)"
                    (selectionChanged)="productSelectionChanged($event)"
                    (chooseCatalogItems)="productChooser()?.open($event)">
                    <se-fe-icon-button productTableToolbarActions [seFeMenuTrigger]="productTableMenu">
                      <se-fe-icon
                        seFeDataName="more"
                        seFeDataSize="600"
                        seFeDataColor="default"
                        seFeDataAriaLabel="Catalog product actions"></se-fe-icon>
                    </se-fe-icon-button>
                  </product-table>
                  <se-fe-menu #productTableMenu [seFeDataOptions]="productMenuOptions"></se-fe-menu>
                } @else {
                  @if (bundlesError$ | async; as bundlesError) {
                    <se-fe-alert seFeDataType="error">
                      Catalog bundles could not be loaded
                      <se-fe-alert-subheader>{{ bundlesError.message }}</se-fe-alert-subheader>
                    </se-fe-alert>
                  }

                  <product-table
                    mode="catalogBundle"
                    linkPrefix="../../bundles/"
                    [loading]="(bundlesLoading$ | async) ?? false"
                    [products]="(bundles$ | async) ?? []"
                    [paginationEnabled]="true"
                    [paginationOptions]="(bundlePaginationOptions$ | async) ?? undefined"
                    [query]="(bundleQuery$ | async) ?? ''"
                    [selectable]="true"
                    [selectedRowIds]="selectedBundleIds()"
                    [showRemove]="true"
                    [showSearch]="true"
                    [showToolbarFilters]="false"
                    [showCatalogEmptyState]="true"
                    [sortBy]="(bundleSortBy$ | async) ?? undefined"
                    [sortDirection]="(bundleSortDirection$ | async) ?? undefined"
                    (queryChanged)="bundleQueryChanged($event)"
                    (removeProduct)="removeBundleFromCatalog($event)"
                    (selectionChanged)="bundleSelectionChanged($event)"
                    (chooseCatalogItems)="bundleChooser()?.open($event)">
                    <se-fe-icon-button productTableToolbarActions [seFeMenuTrigger]="bundleTableMenu">
                      <se-fe-icon
                        seFeDataName="more"
                        seFeDataSize="600"
                        seFeDataColor="default"
                        seFeDataAriaLabel="Catalog bundle actions"></se-fe-icon>
                    </se-fe-icon-button>
                  </product-table>
                  <se-fe-menu #bundleTableMenu [seFeDataOptions]="bundleMenuOptions"></se-fe-menu>
                }
              </se-fe-tab-panel>
            </se-fe-card-content>
          </se-fe-card>
        </se-fe-grid-cell>

        <se-fe-grid-cell seFeGridOpts="1/1@mobile 1/3@desktop">
          <se-fe-grid seFeGridOpts>
            <se-fe-grid-cell seFeGridOpts="1/1">
              <se-fe-card class="catalog-detail__settings-card">
                <se-fe-card-header seFeDataTitle="Catalog settings" [seFeDataHeavyBorder]="true">
                  <app-edit-catalog-modal seFeCardHeaderActions></app-edit-catalog-modal>
                </se-fe-card-header>
                <se-fe-card-content>
                  <dl class="catalog-detail__settings">
                    <div>
                      <dt>Catalog name</dt>
                      <dd>{{ catalog.name }}</dd>
                    </div>
                    <div>
                      <dt>Description</dt>
                      <dd>{{ catalog.description || '--' }}</dd>
                    </div>
                  </dl>
                </se-fe-card-content>
              </se-fe-card>
            </se-fe-grid-cell>

            @if (registrations$ | async; as registrations) {
              @if (registrations.length) {
                <se-fe-grid-cell seFeGridOpts="1/1">
                  <se-fe-card class="catalog-detail__registrations-card">
                    <se-fe-card-header
                      seFeDataTitle="Registrations"
                      seFeDataSubtitle="Registrations this catalog is sold in"
                      [seFeDataHeavyBorder]="true"></se-fe-card-header>
                    <se-fe-card-content>
                      <ul class="catalog-detail__registrations">
                        @for (registration of registrations; track registration.id) {
                          <li>
                            <a
                              seFeLink="low"
                              target="_blank"
                              rel="noopener noreferrer"
                              [attr.href]="registration.survey_url">
                              {{ registration.name }}
                            </a>
                          </li>
                        }
                      </ul>
                      <a
                        se-fe-button-low
                        class="catalog-detail__registrations-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        [attr.href]="registrationListUrl()">
                        Go to registrations
                      </a>
                    </se-fe-card-content>
                  </se-fe-card>
                </se-fe-grid-cell>
              }
            }
          </se-fe-grid>
        </se-fe-grid-cell>
      </se-fe-grid>
    }
  </ng-container>
</se-fe-page>
